// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file annealing/delivery/v1/enums.proto (package annealing.delivery.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file annealing/delivery/v1/enums.proto.
 */
export const file_annealing_delivery_v1_enums: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from enum annealing.delivery.v1.SshKeyState
 */
export enum SshKeyState {
  /**
   * @generated from enum value: SSH_KEY_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SSH_KEY_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: SSH_KEY_STATE_ACTIVE = 2;
   */
  ACTIVE = 2,
}

/**
 * Describes the enum annealing.delivery.v1.SshKeyState.
 */
export const SshKeyStateSchema: GenEnum<SshKeyState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 0);

/**
 * @generated from enum annealing.delivery.v1.SshKnownHostState
 */
export enum SshKnownHostState {
  /**
   * @generated from enum value: SSH_KNOWN_HOST_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SSH_KNOWN_HOST_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: SSH_KNOWN_HOST_STATE_ACTIVE = 2;
   */
  ACTIVE = 2,
}

/**
 * Describes the enum annealing.delivery.v1.SshKnownHostState.
 */
export const SshKnownHostStateSchema: GenEnum<SshKnownHostState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 1);

/**
 * @generated from enum annealing.delivery.v1.IgnoreDifferenceState
 */
export enum IgnoreDifferenceState {
  /**
   * @generated from enum value: IGNORE_DIFFERENCE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: IGNORE_DIFFERENCE_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: IGNORE_DIFFERENCE_STATE_ACTIVE = 2;
   */
  ACTIVE = 2,
}

/**
 * Describes the enum annealing.delivery.v1.IgnoreDifferenceState.
 */
export const IgnoreDifferenceStateSchema: GenEnum<IgnoreDifferenceState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 2);

/**
 * @generated from enum annealing.delivery.v1.IgnoreDifferenceType
 */
export enum IgnoreDifferenceType {
  /**
   * @generated from enum value: IGNORE_DIFFERENCE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: IGNORE_DIFFERENCE_TYPE_JSON_POINTER = 1;
   */
  JSON_POINTER = 1,

  /**
   * @generated from enum value: IGNORE_DIFFERENCE_TYPE_JQ_PATH_EXPRESSION = 2;
   */
  JQ_PATH_EXPRESSION = 2,

  /**
   * @generated from enum value: IGNORE_DIFFERENCE_TYPE_MANAGED_FIELDS_MANAGER = 3;
   */
  MANAGED_FIELDS_MANAGER = 3,
}

/**
 * Describes the enum annealing.delivery.v1.IgnoreDifferenceType.
 */
export const IgnoreDifferenceTypeSchema: GenEnum<IgnoreDifferenceType> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 3);

/**
 * @generated from enum annealing.delivery.v1.ClusterState
 */
export enum ClusterState {
  /**
   * @generated from enum value: CLUSTER_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLUSTER_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: CLUSTER_STATE_CONNECTED = 2;
   */
  CONNECTED = 2,

  /**
   * @generated from enum value: CLUSTER_STATE_DISCONNECTED = 3;
   */
  DISCONNECTED = 3,
}

/**
 * Describes the enum annealing.delivery.v1.ClusterState.
 */
export const ClusterStateSchema: GenEnum<ClusterState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 4);

/**
 * @generated from enum annealing.delivery.v1.ApplicationState
 */
export enum ApplicationState {
  /**
   * @generated from enum value: APPLICATION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: APPLICATION_STATE_ACTIVE = 1;
   */
  ACTIVE = 1,
}

/**
 * Describes the enum annealing.delivery.v1.ApplicationState.
 */
export const ApplicationStateSchema: GenEnum<ApplicationState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 5);

/**
 * @generated from enum annealing.delivery.v1.IncarnationState
 */
export enum IncarnationState {
  /**
   * @generated from enum value: INCARNATION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INCARNATION_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: INCARNATION_STATE_RENDERING = 2;
   */
  RENDERING = 2,

  /**
   * @generated from enum value: INCARNATION_STATE_RENDERED = 3;
   */
  RENDERED = 3,

  /**
   * @generated from enum value: INCARNATION_STATE_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * Describes the enum annealing.delivery.v1.IncarnationState.
 */
export const IncarnationStateSchema: GenEnum<IncarnationState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 6);

/**
 * @generated from enum annealing.delivery.v1.GitRepositoryState
 */
export enum GitRepositoryState {
  /**
   * @generated from enum value: GIT_REPOSITORY_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GIT_REPOSITORY_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: GIT_REPOSITORY_STATE_CONNECTED = 2;
   */
  CONNECTED = 2,

  /**
   * @generated from enum value: GIT_REPOSITORY_STATE_DISCONNECTED = 3;
   */
  DISCONNECTED = 3,
}

/**
 * Describes the enum annealing.delivery.v1.GitRepositoryState.
 */
export const GitRepositoryStateSchema: GenEnum<GitRepositoryState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 7);

/**
 * @generated from enum annealing.delivery.v1.ChartRepositoryState
 */
export enum ChartRepositoryState {
  /**
   * @generated from enum value: CHART_REPOSITORY_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHART_REPOSITORY_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: CHART_REPOSITORY_STATE_CONNECTED = 2;
   */
  CONNECTED = 2,

  /**
   * @generated from enum value: CHART_REPOSITORY_STATE_DISCONNECTED = 3;
   */
  DISCONNECTED = 3,
}

/**
 * Describes the enum annealing.delivery.v1.ChartRepositoryState.
 */
export const ChartRepositoryStateSchema: GenEnum<ChartRepositoryState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 8);

/**
 * @generated from enum annealing.delivery.v1.ChartState
 */
export enum ChartState {
  /**
   * @generated from enum value: CHART_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHART_STATE_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: CHART_STATE_REMOVED = 2;
   */
  REMOVED = 2,
}

/**
 * Describes the enum annealing.delivery.v1.ChartState.
 */
export const ChartStateSchema: GenEnum<ChartState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 9);

/**
 * AssetPinReason represents the reason for the spec change.
 *
 * @generated from enum annealing.delivery.v1.AssetPinReason
 */
export enum AssetPinReason {
  /**
   * @generated from enum value: ASSET_PIN_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSET_PIN_REASON_CREATE = 1;
   */
  CREATE = 1,

  /**
   * @generated from enum value: ASSET_PIN_REASON_FAST_FORWARD = 2;
   */
  FAST_FORWARD = 2,

  /**
   * @generated from enum value: ASSET_PIN_REASON_CANARY = 3;
   */
  CANARY = 3,

  /**
   * @generated from enum value: ASSET_PIN_REASON_ROLLOUT = 4;
   */
  ROLLOUT = 4,

  /**
   * @generated from enum value: ASSET_PIN_REASON_ROLLBACK = 5;
   */
  ROLLBACK = 5,

  /**
   * @generated from enum value: ASSET_PIN_REASON_REVERT = 6;
   */
  REVERT = 6,

  /**
   * @generated from enum value: ASSET_PIN_REASON_DESTROY = 7;
   */
  DESTROY = 7,

  /**
   * @generated from enum value: ASSET_PIN_REASON_ABANDON = 8;
   */
  ABANDON = 8,
}

/**
 * Describes the enum annealing.delivery.v1.AssetPinReason.
 */
export const AssetPinReasonSchema: GenEnum<AssetPinReason> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 10);

/**
 * @generated from enum annealing.delivery.v1.SyncState
 */
export enum SyncState {
  /**
   * @generated from enum value: SYNC_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SYNC_STATE_OUT_OF_SYNC = 1;
   */
  OUT_OF_SYNC = 1,

  /**
   * @generated from enum value: SYNC_STATE_SYNCED = 2;
   */
  SYNCED = 2,

  /**
   * @generated from enum value: SYNC_STATE_UNKNOWN = 3;
   */
  UNKNOWN = 3,
}

/**
 * Describes the enum annealing.delivery.v1.SyncState.
 */
export const SyncStateSchema: GenEnum<SyncState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 11);

/**
 * @generated from enum annealing.delivery.v1.HealthState
 */
export enum HealthState {
  /**
   * @generated from enum value: HEALTH_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: HEALTH_STATE_MISSING = 1;
   */
  MISSING = 1,

  /**
   * @generated from enum value: HEALTH_STATE_PROGRESSING = 2;
   */
  PROGRESSING = 2,

  /**
   * @generated from enum value: HEALTH_STATE_HEALTHY = 3;
   */
  HEALTHY = 3,

  /**
   * @generated from enum value: HEALTH_STATE_DEGRADED = 4;
   */
  DEGRADED = 4,

  /**
   * @generated from enum value: HEALTH_STATE_SUSPENDED = 5;
   */
  SUSPENDED = 5,
}

/**
 * Describes the enum annealing.delivery.v1.HealthState.
 */
export const HealthStateSchema: GenEnum<HealthState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 12);

/**
 * @generated from enum annealing.delivery.v1.AssetState
 */
export enum AssetState {
  /**
   * @generated from enum value: ASSET_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSET_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: ASSET_STATE_RECONCILING = 2;
   */
  RECONCILING = 2,

  /**
   * @generated from enum value: ASSET_STATE_RECONCILED = 3;
   */
  RECONCILED = 3,

  /**
   * @generated from enum value: ASSET_STATE_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: ASSET_STATE_REVERTED = 5;
   */
  REVERTED = 5,
}

/**
 * Describes the enum annealing.delivery.v1.AssetState.
 */
export const AssetStateSchema: GenEnum<AssetState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 13);

/**
 * @generated from enum annealing.delivery.v1.AssetEventType
 */
export enum AssetEventType {
  /**
   * @generated from enum value: ASSET_EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSET_EVENT_TYPE_PUSH_START = 1;
   */
  PUSH_START = 1,

  /**
   * @generated from enum value: ASSET_EVENT_TYPE_PUSH_END = 2;
   */
  PUSH_END = 2,

  /**
   * @generated from enum value: ASSET_EVENT_TYPE_NO_DIFF = 3;
   */
  NO_DIFF = 3,
}

/**
 * Describes the enum annealing.delivery.v1.AssetEventType.
 */
export const AssetEventTypeSchema: GenEnum<AssetEventType> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 14);

/**
 * @generated from enum annealing.delivery.v1.RolloutState
 */
export enum RolloutState {
  /**
   * @generated from enum value: ROLLOUT_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROLLOUT_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: ROLLOUT_STATE_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: ROLLOUT_STATE_SUCCEEDED = 3;
   */
  SUCCEEDED = 3,

  /**
   * @generated from enum value: ROLLOUT_STATE_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: ROLLOUT_STATE_PAUSING = 5;
   */
  PAUSING = 5,

  /**
   * @generated from enum value: ROLLOUT_STATE_PAUSED = 6;
   */
  PAUSED = 6,

  /**
   * @generated from enum value: ROLLOUT_STATE_ABORTING = 7;
   */
  ABORTING = 7,

  /**
   * @generated from enum value: ROLLOUT_STATE_ABORTED = 8;
   */
  ABORTED = 8,
}

/**
 * Describes the enum annealing.delivery.v1.RolloutState.
 */
export const RolloutStateSchema: GenEnum<RolloutState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 15);

/**
 * @generated from enum annealing.delivery.v1.RolloutStepKind
 */
export enum RolloutStepKind {
  /**
   * @generated from enum value: ROLLOUT_STEP_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROLLOUT_STEP_KIND_APPLY_ACTION = 1;
   */
  APPLY_ACTION = 1,

  /**
   * @generated from enum value: ROLLOUT_STEP_KIND_DESTROY_ACTION = 2;
   */
  DESTROY_ACTION = 2,

  /**
   * @generated from enum value: ROLLOUT_STEP_KIND_PURGE_ACTION = 3;
   */
  PURGE_ACTION = 3,
}

/**
 * Describes the enum annealing.delivery.v1.RolloutStepKind.
 */
export const RolloutStepKindSchema: GenEnum<RolloutStepKind> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 16);

/**
 * @generated from enum annealing.delivery.v1.RolloutStepState
 */
export enum RolloutStepState {
  /**
   * @generated from enum value: ROLLOUT_STEP_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROLLOUT_STEP_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: ROLLOUT_STEP_STATE_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: ROLLOUT_STEP_STATE_SUCCEEDED = 3;
   */
  SUCCEEDED = 3,

  /**
   * @generated from enum value: ROLLOUT_STEP_STATE_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * Describes the enum annealing.delivery.v1.RolloutStepState.
 */
export const RolloutStepStateSchema: GenEnum<RolloutStepState> = /*@__PURE__*/
  enumDesc(file_annealing_delivery_v1_enums, 17);

